function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === 'function') {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useMemo, useReducer } from "react";
import { useNavigationActiveLock } from "@sprout/list-navigation";
const initialState = {};
const PostPageEditorContext = /*#__PURE__*/ createContext({
    state: initialState,
    dispatch: ()=>null
});
function reducer(state, action) {
    switch(action.type){
        case "SET_EDITOR":
            {
                const { payload  } = action;
                return payload;
            }
        case "CLOSE_EDITOR":
            return {};
        default:
            return state;
    }
}
export function usePostPageEditor() {
    return useContext(PostPageEditorContext);
}
export const PostPageEditorProvider = (props)=>{
    const [state, dispatch] = useReducer(reducer, initialState);
    useNavigationActiveLock(state.editor !== undefined);
    const value = useMemo(()=>({
            state,
            dispatch
        }), [
        state
    ]);
    return /*#__PURE__*/ _jsx(PostPageEditorContext.Provider, _objectSpread({
        value: value
    }, props));
};
